import { AdminTemplate, MerchantEndOfDayComponent } from "../../components";

export const MerchantEndOfDay = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "",
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true,
      }}
      showHeaderTitle={false}>
      <MerchantEndOfDayComponent />
    </AdminTemplate>
  );
};
